import { supabase } from '../supabaseClient';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const JSON_HEADERS = { 'Content-Type': 'application/json' };

const handleResponse = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    data = null;
  }

  if (!response.ok) {
    const message = data?.detail || data?.message || 'Unable to complete request';
    throw new Error(message);
  }

  return data;
};

export const loginUser = async (email, password) => {
  const response = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: JSON_HEADERS,
    credentials: 'include',
    body: JSON.stringify({ email, password }),
  });

  return handleResponse(response);
};

export const signupUser = async ({ email, password, name }) => {
  const response = await fetch(`${API_BASE}/auth/signup`, {
    method: 'POST',
    headers: JSON_HEADERS,
    credentials: 'include',
    body: JSON.stringify({ email, password, name }),
  });

  return handleResponse(response);
};

export const logoutUser = async (accessToken) => {
  try {
    const response = await fetch(`${API_BASE}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: accessToken
        ? {
            ...JSON_HEADERS,
            Authorization: `Bearer ${accessToken}`,
          }
        : JSON_HEADERS,
    });

    if (!response.ok) {
      console.warn('Logout request failed', response.status);
    }
  } catch (error) {
    console.warn('Logout request failed', error);
  }
};

export const requestPasswordReset = async (email) => {
  const response = await fetch(`${API_BASE}/auth/forgot-password`, {
    method: 'POST',
    headers: JSON_HEADERS,
    credentials: 'include',
    body: JSON.stringify({ email }),
  });

  return handleResponse(response);
};

export const updatePasswordWithToken = async (accessToken, newPassword) => {
  const response = await fetch(`${API_BASE}/auth/user`, {
    method: 'PUT',
    headers: {
      ...JSON_HEADERS,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ password: newPassword }),
  });

  return handleResponse(response);
};

export const startGoogleOAuth = async (redirectTo) => {
  const redirect = redirectTo || `${window.location.origin}/oauth/callback`;
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: redirect },
  });
  if (error) throw error;
  return data;
};

export const fetchCurrentUser = async (accessToken) => {
  const response = await fetch(`${API_BASE}/auth/user`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return handleResponse(response);
};
